import { lazy } from 'react';

import { withSuspense } from '@/shared-ui/styles/withSuspense/withSuspense';
import { UserRole } from '@/types';

const ConfirmConsultation = withSuspense(lazy(() => import('@/pages/ConfirmConsultation')));
const ConsultationDoubleBookings = withSuspense(lazy(() => import('@/pages/ConsultationDoubleBookings')));
const Consultations = withSuspense(lazy(() => import('@/pages/Consultations')));
const DassAssessmentForm = withSuspense(lazy(() => import('@/pages/DassAssessmentForm')));
const DassAssessmentScorePage = withSuspense(
  lazy(() => import('@/components/DassAssessmentForm/DassAssessmentScorePage')),
);
const DoctorCalendar = withSuspense(lazy(() => import('@/pages/DoctorCalendar')));
const Doctors = withSuspense(lazy(() => import('@/pages/Doctors')));
const DoctorScheduler = withSuspense(lazy(() => import('@/pages/DoctorScheduler')));
const DoctorScriptReview = withSuspense(lazy(() => import('@/pages/DoctorsScriptReview')));
const IhiReviewLogs = withSuspense(lazy(() => import('@/pages/IhiReviewLogs')));
const Login = withSuspense(lazy(() => import('@/pages/Login')));
const NurseCalendar = withSuspense(lazy(() => import('@/pages/NurseCalendar')));
const Nurses = withSuspense(lazy(() => import('@/pages/Nurses')));
const NurseScheduler = withSuspense(lazy(() => import('@/pages/NurseScheduler')));
const OnBoardDoctor = withSuspense(lazy(() => import('@/pages/OnboardDoctor')));
const OnBoardNurse = withSuspense(lazy(() => import('@/pages/OnboardNurse')));
const OnBoardPatient = withSuspense(lazy(() => import('@/pages/OnboardPatient')));
const PageNotFound = withSuspense(lazy(() => import('@/pages/404')));
const Patient = withSuspense(lazy(() => import('@/pages/Patient')));
const PatientConsentForm = withSuspense(lazy(() => import('@/pages/PatientConsent')));
const Patients = withSuspense(lazy(() => import('@/pages/Patients')));
const Prescriptions = withSuspense(lazy(() => import('@/pages/Prescriptions')));
const ProductCatalog = withSuspense(lazy(() => import('@/pages/ProductCatalog')));
const ProductOffering = withSuspense(lazy(() => import('@/pages/ProductOffering')));
const PubLogin = withSuspense(lazy(() => import('@/pages/PubLogin')));
const DoctorRoundRobin = withSuspense(lazy(() => import('@/pages/DoctorRoundRobin')));
const DoctorRoundRobins = withSuspense(lazy(() => import('@/pages/DoctorRoundRobins')));
const RoundRobinNurses = withSuspense(lazy(() => import('@/pages/RoundRobinNurses')));
const SupportSelfService = withSuspense(lazy(() => import('@/pages/SupportSelfService')));
const ViewImage = withSuspense(lazy(() => import('@/pages/ViewImage')));

export type RouteType = {
  path: string;
  component: React.FunctionComponent;
  isPrivate: boolean;
  navBar?: boolean;
  restrictAccess?: UserRole[];
  hideAmazonConnect?: boolean;
};

export const routes: RouteType[] = [
  {
    path: '/',
    component: Login,
    isPrivate: false,
    navBar: true,
    hideAmazonConnect: true,
  },
  {
    path: '/8C4yKU8CEa6pb',
    component: PubLogin,
    isPrivate: false,
    navBar: true,
    hideAmazonConnect: true,
  },
  {
    path: '/confirm-consultation',
    component: ConfirmConsultation,
    isPrivate: false,
    navBar: false,
    hideAmazonConnect: true,
  },
  {
    path: '/patients/:id',
    component: Patient,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/nurses',
    component: Nurses,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/nurse-calendar',
    component: NurseCalendar,
    isPrivate: true,
    restrictAccess: [UserRole.Doctor],
    navBar: true,
  },
  {
    path: '/nurse-scheduler',
    component: NurseScheduler,
    isPrivate: true,
    restrictAccess: [UserRole.Doctor],
    navBar: true,
  },
  {
    path: '/doctor-scheduler',
    component: DoctorScheduler,
    isPrivate: true,
    restrictAccess: [UserRole.Doctor],
    navBar: true,
  },
  {
    path: '/calendar',
    component: DoctorCalendar,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/patients/:id?',
    component: Patients,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/prescriptions',
    component: Prescriptions,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/consultations',
    component: Consultations,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/doctors',
    component: Doctors,
    isPrivate: true,
    restrictAccess: [UserRole.Doctor],
    navBar: true,
  },
  {
    path: '/patients/onboard/new',
    component: OnBoardPatient,
    isPrivate: true,
    restrictAccess: [UserRole.Admin, UserRole.Doctor],
    navBar: true,
  },
  {
    path: '/doctors/onboard/new',
    component: OnBoardDoctor,
    isPrivate: true,
    restrictAccess: [UserRole.Admin, UserRole.Nurse, UserRole.Doctor],
    navBar: true,
  },
  {
    path: '/doctors/rescript',
    component: DoctorScriptReview,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/viewImage/:key?',
    component: ViewImage,
    isPrivate: true,
    hideAmazonConnect: true,
  },
  {
    path: '/Product-catalog',
    component: ProductCatalog,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/product-detail/:id',
    component: ProductOffering,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/onboard-new-nurse',
    component: OnBoardNurse,
    isPrivate: true,
    restrictAccess: [UserRole.Doctor, UserRole.Patient, UserRole.Nurse, UserRole.Admin],
    navBar: true,
  },
  {
    path: '/dash-assessment-form/:patient_id/:uuid',
    component: DassAssessmentForm,
    isPrivate: false,
    navBar: false,
    hideAmazonConnect: true,
  },
  {
    path: '/dash-assessment-score/:patient_id',
    component: DassAssessmentScorePage,
    isPrivate: false,
    navBar: false,
    hideAmazonConnect: true,
  },
  {
    path: '/consent-form/:patientId/:uuid',
    component: PatientConsentForm,
    isPrivate: false,
    navBar: false,
    hideAmazonConnect: true,
  },
  {
    path: '/roundrobin-doctors',
    component: DoctorRoundRobins,
    isPrivate: true,
    restrictAccess: [UserRole.Doctor, UserRole.Patient, UserRole.Nurse, UserRole.Admin],
    navBar: true,
  },
  {
    path: '/roundrobin-doctors/:eventTypeId',
    component: DoctorRoundRobin,
    isPrivate: true,
    restrictAccess: [UserRole.Doctor, UserRole.Patient, UserRole.Nurse, UserRole.Admin],
    navBar: true,
  },
  {
    path: '/roundrobin-nurses',
    component: RoundRobinNurses,
    isPrivate: true,
    navBar: true,
  },
  {
    path: '/support-self-service',
    component: SupportSelfService,
    isPrivate: true,
    restrictAccess: [UserRole.Patient],
    navBar: true,
  },

  {
    path: '/ihi-review-logs',
    component: IhiReviewLogs,
    isPrivate: true,
    restrictAccess: [UserRole.Doctor, UserRole.Patient, UserRole.Nurse, UserRole.Admin],
    navBar: true,
  },
  {
    path: '/consultation-double-bookings',
    component: ConsultationDoubleBookings,
    isPrivate: true,
    restrictAccess: [UserRole.Doctor, UserRole.Patient],
    navBar: true,
  },
  {
    path: '/*',
    component: PageNotFound,
    isPrivate: false,
    navBar: true,
    hideAmazonConnect: true,
  },
];
